export var MainAxisAlignments;
(function (MainAxisAlignments) {
    MainAxisAlignments["start"] = "flex-start";
    MainAxisAlignments["center"] = "center";
    MainAxisAlignments["end"] = "flex-end";
    MainAxisAlignments["spaceBetween"] = "space-between";
    MainAxisAlignments["spaceAround"] = "space-around";
    MainAxisAlignments["spaceEvenly"] = "space-evenly";
    MainAxisAlignments["stretch"] = "stretch";
})(MainAxisAlignments || (MainAxisAlignments = {}));
export var CrossAxisAlignments;
(function (CrossAxisAlignments) {
    CrossAxisAlignments["start"] = "flex-start";
    CrossAxisAlignments["center"] = "center";
    CrossAxisAlignments["end"] = "flex-end";
    CrossAxisAlignments["stretch"] = "stretch";
    CrossAxisAlignments["baseline"] = "baseline";
})(CrossAxisAlignments || (CrossAxisAlignments = {}));
var Alignments;
(function (Alignments) {
    Alignments["top"] = "top";
    Alignments["bottom"] = "bottom";
    Alignments["left"] = "left";
    Alignments["center"] = "center";
    Alignments["right"] = "right";
})(Alignments || (Alignments = {}));
export default Alignments;
